export default {
  AUTH_SET: 'AUTH_SET',
};
